const defaultRender = (value) => (value ? value : '--');

const columns = [
    {
        title: 'Activity',
        dataIndex: 'activity',
        render: defaultRender,
    },
    {
        title: 'Message',
        dataIndex: 'activity_message',
        render: defaultRender,
    },
    {
        title: 'Created Date',
        dataIndex: 'created_at',
        render: defaultRender,
    },
];

export default columns;